export interface MidiEvent {
    sourceId: string;
    note: number;
    type: 'start' | 'end';
    timestamp: number;
    velocity: number;
}

export class EventToNoteSequenceBuffer {
    private activeNotes: Map<string, Map<number, MidiEvent>>; // Maps sourceId -> note ->  start timestamp
    private onNoteComplete: (
        sourceId: string,
        start: number,
        note: number,
        duration: number,
        velocity: number
    ) => void;

    constructor(
        onNoteComplete: (
            sourceId: string,
            start: number,
            note: number,
            duration: number,
            velocity: number
        ) => void
    ) {
        this.activeNotes = new Map();
        this.onNoteComplete = onNoteComplete;
    }

    processEvent(event: MidiEvent): void {
        if (event.type === 'start') {
            if (!this.activeNotes.has(event.sourceId)) {
                this.activeNotes.set(event.sourceId, new Map());
            }
            const sourceNotes = this.activeNotes.get(event.sourceId)!;
            sourceNotes.set(event.note, event);
        } else if (event.type === 'end') {
            const startEvent = this.activeNotes.get(event.sourceId)?.get(event.note);
            if (!startEvent) return;
            const startTimestamp = startEvent.timestamp;
            if (startTimestamp !== undefined) {
                const duration = event.timestamp - startTimestamp;
                this.onNoteComplete(event.sourceId, startTimestamp, event.note, duration, startEvent.velocity);
            }
            this.activeNotes.get(event.sourceId)!.delete(event.note);
        }
    }
}